﻿module Ui.Language

module Keys =

    let Language = 0
    let SwitchOrgs = 1
    let ORG = 2
    let Logout = 3
    let SignOut = 4
    let CloseMenu = 5
    let Vendor = 6
    let Council = 7
    let SoleProprietorship = 8
    let Partnership = 9
    let SCorp = 10
    let CCorp = 11
    let LLC = 12
    let JointVenture = 13
    let WhollyOwnedSubsidiary = 14
    let Individual = 15
    let Unanswered = 16
    let VendorSignUp = 17
    let SUCCESS = 18
    let CQRegistrationSubmittedCheckEmail = 19
    let ReturnToLogin = 20
    let UserInformation = 21
    let RequestedSites = 22
    let ConfirmInformation = 23
    let SearchForSite = 24
    let SelectAllThatApply = 25
    let ErrorLoadingData = 26
    let VerifyYourInformation = 27
    let EditCompanyInformation = 28
    let EditPrimaryUser = 29
    let EditRequestedSites = 30
    let SearchForSitesFailed = 31
    let AttachAdditionalInformation = 32
    let Notes = 33
    let Documents = 34
    let AuditStatus = 35
    let RenewalStatus = 36
    let PendingAuditExemptionRequest = 37
    let ClickToViewRequest = 38
    let ClickToViewApproval = 39
    let ReviewExemptionApproval = 40
    let LoadingEllipsis = 41
    let PageError = 42
    let ReviewApproval = 43
    let AuditExemptionApproved = 44
    let SupportingDocuments = 45
    let SupportingFile = 46
    let NoAttachedDocuments = 47
    let ReviewExemptionRequest = 48
    let ReviewRequest = 49
    let Request = 50
    let AuditExemption = 51
    let NoVednorsLinked = 52
    let NoVendorsBlockedFromRenewal = 53
    let ClientHomePage = 54
    let VendorContactInfoNotCompleted = 55
    let VendorOfficeInfoNotCompleted = 56
    let ThreeYearAverage = 57
    let IncidentHistoryQuestionnaire = 58
    let InProgress = 59
    let Active = 60
    let Inactive = 61
    let All = 62
    let Renewing = 63
    let NotRenewing = 64
    let Undefined = 65
    let Unknown = 66
    let InProgressNew = 67
    let AuditExemptionRequested = 68
    let ApprovedAuditExemption = 69
    let DeniedAuditExemptionRequest = 70
    let AuditExemptionRequestCanceled = 71
    let AuditApproved = 72
    let AuditExpired = 73
    let LoadingDataFailed = 74
    let SavingDataFailed = 75
    let CommandError = 76
    let PleaseContactCQSupportWithDetails = 77
    let RetryLaterOrGiveDevsInfo = 78
    let SaveFailed = 79
    let SomethingWentWrongEllipsis = 80
    let ThisAppOutOfDateTryReloadingIfStillContactSupport = 81
    let CouldNotUnderstandServerResponse = 82
    let YourLoginProbablyExpiredTryReloginIfStillContactSupport = 83
    let AccountNotLinkedToOrganizationsContactAdminOrSupport = 84
    let BackToProfile = 85
    let ContactCQSupport = 86
    let Search = 87
    let Edit = 88
    let PerPage = 89
    let Add = 90
    let Details = 91
    let details = 92
    let Continue = 93
    let Next = 94
    let Start = 95
    let View = 96
    let Review = 97
    let PendingReview = 98
    let Reviewed = 99
    let Back = 100
    let Close = 101
    let No = 102
    let NO = 103
    let Yes = 104
    let YES = 105
    let Cancel = 106
    let Undo = 107
    let DoNotDelete = 108
    let Delete = 109
    let Remove = 110
    let remove = 111
    let Removing = 112
    let Done = 113
    let Submitting = 114
    let Submit = 115
    let Reload = 116
    let DBA = 117
    let PhysicalAddress = 118
    let Street = 119
    let CityTown = 120
    let StateProvince = 121
    let PostalCode = 122
    let Country = 123
    let Name = 124
    let Title = 125
    let Phone = 126
    let Email = 127
    let Activate = 128
    let ActivationAllowsUserLogin = 129
    let CreateVendorUser = 130
    let UserAdded = 131
    let ViewTheAddedUser = 132
    let AddAnotherUser = 133
    let FirstName = 134
    let LastName = 135
    let Role = 136
    let SuperUser = 137
    let SuperUsersRoleInfo = 138
    let Standard = 139
    let StandardUsersRoleInfo = 140
    let ViewOnly = 141
    let ViewOnlyRoleInfo = 142
    let ChangeEmail = 143
    let NewEmail = 144
    let ChangeUserName = 145
    let ChangeUserPhone = 146
    let NewUserPhone = 147
    let ChangeRole = 148
    let Deactivate = 149
    let AfterDeactivationUserCanNotLogOn = 150
    let IfCurrentlyLoggedLoseAccessInHour = 151
    let DeleteThisUser = 152
    let AfterDeletionCanNotLogOn = 153
    let ReinviteUser = 154
    let NeverReceivedNeverActedOnOriginalEmailInvite = 155
    let UserWillReceiveInviteEmail = 156
    let Reinvite = 157
    let BackToUsers = 158
    let NoUserSelected = 159
    let UserList = 160
    let Activity = 161
    let AddNewUser = 162
    let Files = 163
    let ReviewedDocuments = 164
    let NoFilesReviewed = 165
    let Type = 166
    let Expiration = 167
    let Link = 168
    let FilesPendingReview = 169
    let PendingDocuments = 170
    let NoFilesUploadedClickToStart = 171
    let UploadDocuments = 172
    let uploadingEllipsis = 173
    let RemoveFile = 174
    let YouSureDeleteFile = 175
    let AddingAndRemovingClients = 176
    let SearchClientSiteClickClientToAddYouAgreeToAuditing = 177
    let SelectedSites = 178
    let NoSitesSelected = 179
    let CompanyInformation = 180
    let MaxNumberOfEmployees = 181
    let PrimaryPhysicalAddress = 182
    let CorporateContacts = 183
    let NoCorporateContacts = 184
    let CEO = 185
    let President = 186
    let VicePresident = 187
    let CFOAccounting = 188
    let InsuranceContact = 189
    let NoInsuranceContact = 190
    let SafetyContact = 191
    let NoSafetyContact = 192
    let IsCorporateAccount = 193
    let HowManyYearsInBusinessUnderFirmName = 194
    let DateOfIncorporationWithDateFormat = 195
    let TypeOfBusiness = 196
    let AdditionalOffices = 197
    let NoAdditionalOffices = 198
    let AddOffice = 199
    let GeneralInformationAndContacts = 200
    let PleaseCompleteCompanyContacts = 201
    let CompanyDetails = 202
    let PleaseCompleteCompanyDetails = 203
    let SpecifyAdditionalOffices = 204
    let EditCompanyDetails = 205
    let SelectTypeOfBusiness = 206
    let IfOtherPleaseSpecify = 207
    let EditGeneralInformation = 208
    let CompanyName = 209
    let AnyCorporateContacts = 210
    let HaveInsuranceContact = 211
    let HaveSafetyContact = 212
    let Certifications = 213
    let TypeOfOffice = 214
    let Parent = 215
    let Branch = 216
    let Subsidiary = 217
    let EditAdditionalOffices = 218
    let HaveAnyAdditionalOffices = 219
    let CompanyPolicyDocuments = 220
    let InsuranceDocuments = 221
    let PendingInsuranceDocuments = 222
    let RequirementExpirations = 223
    let CompanyInfo = 224
    let CompanyPolicies = 225
    let ClientSpecific = 226
    let Liability = 227
    let Insurance = 228
    let OSHA300A = 229
    let EMRWCB = 230
    let License = 231
    let Licenses = 232
    let Questionnaire = 233
    let GeneralInformationAndSupportingDocs = 234
    let ClientSpecificDocuments = 235
    let SafetyStatisticsInsuranceAndLicense = 236
    let LiabilityInformation = 237
    let InsuranceCertificates = 238
    let OSHA300ALogsInjuryStatistics = 239
    let EMRWCBRates = 240
    let BusinessProfessionalLicenses = 241
    let YouHaveOpenRequestFromAuditor = 242
    let NotApplicableShortHand = 243
    let Users = 244
    let Clients = 245
    let PolicySamples = 246
    let ContactSupport = 247
    let Status = 248
    let ValidThrough = 249
    let ValidThru = 250
    let RenewingMeansAuditingContinues = 251
    let VendorHomePage = 252
    let LatestAdditions = 253
    let InjuryLogs = 254
    let WhereYouRequiredToKeepOSHALogsOrCanadianInjuryStatsIn = 255
    let YesIHaveLogsFor = 256
    let PleaseAttachInjuryLogsForThatYear = 257
    let PleaseSelectWhy = 258
    let WasNotRequiredToKeepInjuryLogsIn = 259
    let HadNoMoreThan10Employees = 260
    let EnterHighestNumberOfEmployeesForYear = 261
    let TheIndustryFor = 262
    let DoesNotRequireLogsBeKept = 263
    let ProvideIndustryDescription = 264
    let WasNotAnEmployerIn = 265
    let InjuryLogsFor = 266
    let LogsNotRequiredNotYetEstablished = 267
    let LogsNotRequiredLessThan11Employees = 268
    let IndustryNotRequired = 269
    let AddInformation = 270
    let OtherExplanationFileDetails = 271
    let ExplanationOtherDocuments = 272
    let UploadOtherDocuments = 273
    let RemoveInjuryLogsF = 274
    let RemoveExplanationOtherFile = 275
    let IfYesExplain = 276
    let AttachExplanationLetter = 277
    let UploadExplanationDocument = 278
    let EditLiabilityForm = 279
    let everDefaultedOnWorkAwardedToYourCompany = 280
    let TerminatedAnyContractForCauseInLastFiveYears = 281
    let EverFiledBankruptcyPersonallyOrForBusinesses = 282
    let Within3yearsRejectedRequiredReworkCostsInExcessOfFiftyThousandDollars = 283
    let AccidentsResultingInPermanentDisabilityOccurredWithinPastTenYears = 284
    let AccidentsResultingInDeathOccurredWithinPastTenYears = 285
    let AnyJudgmentsClaimsSuitsPendingOutstandingAgainstCompany = 286
    let ReceivedAnyEPACEPACanadaCitationsViolationsAndChargesLastFiveYears = 287
    let ReceivedAnyOSHAOHSCCOHSCitationsViolationsAndChargesLastFiveYears = 288
    let ReceivedAnyDOTTransportCanadCitationsViolationsAndChargesLastFiveYears = 289
    let ReceivedAnyCivilCitationsViolationsAndChargesLastFiveYears = 290
    let ReceivedAnyCriminalCitationsViolationsAndChargesLastFiveYears = 291
    let ReceivedAnyADEMOtherCitationsViolationsAndChargesLastFiveYears = 292
    let ReceivedAnyCitationsViolationsAndChargesFromTheLastFiveYears = 293
    let PendingReviewLiabilityForm = 294
    let LiabilityFormReviewedByCouncils = 295
    let LiabilityForm = 296
    let LiabilityFormNotCompleted = 297
    let UnansweredLiabilityQuestions = 298
    let ClickHereToBeginForm = 299
    let ReviewedLiabilityForm = 300
    let EMRWCBFiles = 301
    let Rate = 302
    let Effective = 303
    let Expires = 304
    let ExpirationDate = 305
    let ClaimedNoWorkersCompensation = 306
    let ClaimedNotQualifiedEMRWCBRateWithExplanationDocuments = 307
    let ClaimedNoEMRWCBRateBecause = 308
    let NotRequiredReviewed = 309
    let ThreeYearAverageEMRWCB = 310
    let CurrentEMRWCB = 311
    let InformationNeeded = 312
    let EMRWCBNotCompleted = 313
    let ClickHereToSubmitInformation = 314
    let SubmitInformation = 315
    let UploadEMRWCBFilesFromLastThreeYears = 316
    let MyCompanyNotRequiredToHaveEMRWCBRate = 317
    let MyCompanyDoesNotHaveWorkersCompensation = 318
    let MyCompanyDoesNotQualify = 319
    let UploadSupportingDocuments = 320
    let OtherReason = 321
    let PleaseExplain = 322
    let SubmissionFailed = 323
    let EMRWCBFilesNeeded = 324
    let VendorProfiles = 325
    let Client = 326
    let Menu = 327
    let ApproveRequest = 328
    let IssueApproval = 329
    let Saving = 330
    let DenyRequest = 331
    let Office = 332
    let RiskAssessment = 333
    let Save = 334
    let IsActive = 335
    let CreateClientUser = 336
    let Required = 337
    let NotYetCompleteEmailAddress = 338
    let EmailInUseByAnotherUser = 339
    let DateInvalid = 340
    let Optional = 341
    let Added = 342
    let PrimaryUser = 343
    let TypePartOfAName = 344
    let ThisIsGreatestNumberPeopleEmployedInPreviousCalendarYear = 345
    let ForVendorsSuppliersContractorsConsultantsEtc = 346
    let CompanySignUp = 347

module Lang =
    // GLOBAL MUTABLE STATE !!! FIXME FIX ME
    // BAD refactor to carry this in a context
    let mutable lang = Array.empty<string>

    // Fable refused to import to a mutable var, so this workaround
    // Have to do this here because static views preload and call getText
    do
        let en_US = Fable.Core.JsInterop.importDefault "../public/Languages/en-US.json"
        lang <- en_US

    let setLang language =
        lang <- language

    let DefaultLang = "en-US"
    let DefaultLangName = "English"
    let LocalStorageLangKey = "language"

    let getText key =
        match Array.tryItem key lang with
        | None ->
            #if DEBUG
            System.Console.WriteLine("key missing: " + key.ToString())
            #endif
            "Translation missing"
        | Some s ->
            match s with
            | "" ->
                #if DEBUG
                System.Console.WriteLine("key empty: " + key.ToString())
                #endif
                "Translation missing"
            | _ -> s